import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiHome } = FiIcons;

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6 relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.1]"></div>
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-cyan-100/30 blur-3xl rounded-full"></div>
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-slate-100/30 blur-3xl rounded-full"></div>

      <div className="relative z-10 text-center">
        <motion.div
          key="notfound-content"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-[12rem] font-black text-slate-100 leading-none select-none">
            404
          </h1>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              System <span className="text-gradient-cyan">Interrupted</span>
            </h2>
            <p className="text-slate-500 text-lg max-w-md mx-auto mb-10">
              The logic you're looking for doesn't exist or has been moved to a different sector.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-8 py-4 bg-slate-900 text-white font-black uppercase tracking-widest text-xs hover:bg-black transition-all group"
              >
                <SafeIcon icon={FiHome} className="text-lg" />
                Return Home
              </Link>
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center gap-2 px-8 py-4 bg-white border border-slate-200 text-slate-600 font-black uppercase tracking-widest text-xs hover:border-cyan-500 hover:text-cyan-600 transition-all"
              >
                <SafeIcon icon={FiArrowLeft} className="text-lg" />
                Go Back
              </button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Code Snippet Decor */}
      <div className="absolute bottom-10 left-10 hidden lg:block opacity-20 font-mono text-xs text-slate-400">
        <pre>{`
  try {
    requestPage(current_url);
  } catch (err) {
    if (err.code === 404) {
      render_not_found();
    }
  }
        `}</pre>
      </div>
    </div>
  );
};

export default NotFound;
